/** Steps項目 */
export const A200_STEPS_ITEMS = [
  { label: '学校情報入力' },
  { label: '入力内容確認' },
  { label: '確認コード入力' },
  { label: '完了' },
];
